/**
 * FT10-U16: Duplicate Payment Analysis (FSD 2.2.2.10). The INT packet spreads
 * `AP_DUPLICATE_PAYMENTS_ROUTES` and adds nav item `ap-duplicate-payments` (p02).
 * The route's permission is the report endpoint's: `ap.report.read`.
 */

import type { RouteRecordRaw } from 'vue-router'

import { DUPLICATE_PAYMENTS_PERMISSIONS } from './api'

export const AP_DUPLICATE_PAYMENTS_ROUTES: RouteRecordRaw[] = [
  {
    path: '/ap/reports/duplicate-payments',
    name: 'ap-duplicate-payments',
    component: () => import('@/modules/ap/reports/duplicate-payments/DuplicatePaymentsView.vue'),
    meta: {
      titleKey: 'ap.routeTitles.duplicatePayments',
      permission: DUPLICATE_PAYMENTS_PERMISSIONS.reportRead,
    },
  },
]
